import React, { useState } from 'react';

import { MdSave } from 'react-icons/md';
import { Form, Input } from '@rocketseat/unform';
import { toast } from 'react-toastify';

import Container from '~/components/Container';
import Title from '~/components/Title';
import Carregando from '~/components/Carregando/Button';
import Footer from '~/components/Footer';
import history from '~/services/history';
import Nav from '~/components/Navigation';

import api from '~/services/api';

import User from '~/components/User';

import { Content, Bloco, Card, Editar } from './styles';

export default function TbGeral() {
  const [loading, setLoading] = useState(false);
  const url = new URL(window.location);
  const params = new URLSearchParams(url.search);
  const tb = params.get('tb');

  async function handleSubmit({ title }) {
    try {
      setLoading(true);
      await api.post('tb/geral', {
        title,
        tb_name: tb,
      });

      setLoading(false);
      toast.success('Cadastrado com sucesso.');
      history.push(`/show/itens?tb=${tb}`);
    } catch (err) {
      setLoading(false);
      toast.error('Algo deu errado. Tente mais tarde.');
    }
  }

  return (
    <>
      <Nav page="itens" />
      <Container>
        <User />

        <Content>
          <Title title={`Itens / Tabelas / ${tb}`} />
          <Bloco>
            <div>
              <h2>Adicionar Tabela</h2>
            </div>
          </Bloco>
        </Content>

        <Card>
          <Editar>
            <Form onSubmit={handleSubmit}>
              <Input name="title" placeholder="Adicionar title" />
              <button type="submit">
                {loading ? (
                  <Carregando />
                ) : (
                  <>
                    <MdSave size={18} color="#fff" /> Salvar
                  </>
                )}
              </button>
            </Form>
          </Editar>
        </Card>

        <Footer />
      </Container>
    </>
  );
}
